import React from 'react'
import { observer } from 'mobx-react'
import { payChannelMobx, payPlanMobx } from '@mobxStore'
import './index.scss'

const ExternalPayNone = () => {
  // 能支付无第三方支付方式时，非 cn 不展示三方支付方式
  const hideExternal = payPlanMobx.canPay && !payPlanMobx.externalMethod && bo !== 'cn'

  return (
    !hideExternal && payChannelMobx.availableExternalMethods.length === 0 ? (
      <div className='external-pay-method-none'>
        <i className='iconfont icon-kongzhuangtai2x' />
        {i18n.t('pay.noExternalPay')}
      </div>
    ) : null
  )
}

export default observer(ExternalPayNone)
